export enum FilePurpose {
  GST_IN_DOCUMENT,
  IEC_DOCUMENT,
  NO_GST_AND_IEC_DOCUMENT,
  PAYOUT_FIRC,
  INVOICE_DOCUMENT,
  COMPANY_LOGO,
  ADDITIONAL_INVOICE_DOCUMENT,
  DEED_DOCUMENT,
  KYB_DOC_OLD_INVOICE,
  KYB_DOC_OLD_FIRC,
  KYB_DOC_CERTIFICATE_ISSUED_BY_MUNICIPAL_AUTHORITY,
  KYB_DOC_CERTIFICATE_ISSUED_BY_TAX_AUTHORITY,
  KYB_DOC_UDYAM_CERTIFICATE,
  KYB_DOC_UTILITY_BILL,
  KYB_DOC_CONTRACT_AGREEMENT,
  USER_PROFILE_PICTURE,
  UBO_PAN,
  UBO_HOME_ADDRESS_PROOF,
}
